import { ColDef } from 'ag-grid-community';

export function swap(input: ColDef[], from: number, to: number): ColDef[] {
    let numberOfDeletedElm = 1;

    const elm = input.splice(from, numberOfDeletedElm)[0];

    numberOfDeletedElm = 0;

    input.splice(to, numberOfDeletedElm, elm);
    return input;
}
